export const EMOJIS = {
  THUMB: '👍',
};
